import Swal from "sweetalert2";

export const showSuccess = (
  title: string,
  text?: string
) => {
  return Swal.fire({
    icon: "success",
    title,
    text,
    confirmButtonColor: "#2563eb",
  });
};

export const showError = (
  title: string,
  text?: string
) => {
  return Swal.fire({
    icon: "error",
    title,
    text,
    confirmButtonColor: "#dc2626",
  });
};

export const showWarning = (
  title: string,
  text?: string
) => {
  return Swal.fire({
    icon: "warning",
    title,
    text,
    confirmButtonColor: "#f59e0b",
  });
};

export const showInfo = (
  title: string,
  text?: string
) => {
  return Swal.fire({
    icon: "info",
    title,
    text,
    confirmButtonColor: "#2563eb",
  });
};

export const showConfirm = async (
  title: string,
  text?: string
): Promise<boolean> => {
  const result = await Swal.fire({
    icon: "question",
    title,
    text,
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#2563eb",
    cancelButtonColor: "#6b7280",
  });

  return result.isConfirmed;
};